import { Pipe, PipeTransform, inject } from '@angular/core';
import { getAnonymousGuestName } from '../../lib/get-anonymous-guest-name';
import { splitName } from '../../lib/split-name';
import { AvatarService, UserLike } from '../../services/avatar.service';
import { StateService } from '../../services/state.service';

@Pipe({
  name: 'avatar',
  standalone: true,
  pure: true,
})
export class AvatarPipe implements PipeTransform {
  private state = inject(StateService);
  private avatarService = inject(AvatarService);

  getAvatar(user: UserLike): string {
    if (user?.['avatar_url']) return user['avatar_url'];

    if (!user) {
      if (!this.state.preGuestAnonymousId) return '';
      return this.avatarService.getAnonymousGuestAvatar(this.state.preGuestAnonymousId);
    }

    if (user['anonymous_id']) {
      const anonymousName = getAnonymousGuestName(user['anonymous_id']);
      if (anonymousName === user['name']) {
        return this.avatarService.getAnonymousGuestAvatar(user['anonymous_id']);
      }
    }

    return this.avatarService.getDefaultUserAvatar(user);
  }

  transform(user: UserLike, tempName?: string): string {
    if (!user && tempName) {
      user = { name: tempName };
    }

    if (user && !user.first_name && (user.name || tempName)) {
      const { first_name: _first_name, last_name: _last_name } = splitName(user.name || tempName);
      user.first_name = _first_name;
      user.last_name = _last_name;
    }

    return this.getAvatar(user);
  }
}
